import React, { useState } from 'react';
const faqs = [{
  question: '¿Cómo recibo el material después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve para cualquier año de la carrera de Medicina?',
  answer: 'Sí. Los 6 tomos están ordenados por bloque temático y cubren toda la carrera: desde primer año con anatomía, fisiología y bioquímica, hasta los años clínicos con semiología, farmacología y medicina interna. Lo usás según lo que estés cursando en este momento.'
}, {
  question: '¿Sirve si recién arranqué la carrera?',
  answer: 'Es ideal para eso. El Tomo 1 está pensado específicamente para aprender a estudiar Medicina desde cero: método de estudio, Active Recall, Anki y cómo planificar la carrera. No asume conocimiento previo — te da el sistema para arrancar con confianza desde el primer día.'
}, {
  question: '¿Funciona para estudiar para finales difíciles?',
  answer: 'Sí. Cada tomo incluye resúmenes por capítulo, mnemotecnias y los temas más frecuentes de final. El Bono de Checklist tiene los 50 temas de anatomía oral más tomados y el Bono de Mnemotecnia cubre plexos, huesos, nervios craneales y más. Varios estudiantes aprobaron materias que habían recursado usando exactamente eso.'
}, {
  question: '¿Los materiales editables de qué nivel son?',
  answer: 'Los 7 editables premium están incluidos en el Sistema de Gestión Académica™ — Nivel 3. Son planillas y documentos que podés adaptar a tu cursada, tus parciales y tus finales. Si elegís el Nivel 1 o el Nivel 2, los materiales vienen en PDF listos para usar.'
}, {
  question: '¿Qué diferencia hay entre los 3 niveles?',
  answer: 'Los tres arrancan con los 6 Tomos y 6 Bonos. El Nivel 2 — Sistema Carrera Organizada™ le suma el Tomo de Guardia y Emergencias y el Tomo de Medicina Interna para los años clínicos. El Nivel 3 — Sistema de Gestión Académica™ incluye todo eso más 7 editables premium para organizar cada aspecto de tu carrera.'
}, {
  question: '¿Qué pasa si tengo materias con mucho contenido teórico?',
  answer: 'Está pensado para eso. En lugar de darte teoría suelta, cada tomo organiza el contenido con lógica clínica y ejemplos aplicados. Fisiología, Farmacología y Anatomía — las materias que más asustan — tienen capítulos completos con mnemotecnias, esquemas y guías paso a paso.'
}, {
  question: '¿Qué diferencia tiene con apuntes o resúmenes del mercado?',
  answer: 'La mayoría de los apuntes que circulan son teoría desorganizada o resúmenes de una sola cátedra. Médico en Proceso™ es un sistema de estudio completo: arranca por el método, sigue por el contenido filtrado de cada materia y termina con herramientas de repaso. Mnemotecnias, checklists, plan de estudio y fichas imprimibles — todo en un solo lugar.'
}, {
  question: '¿Funciona para cualquier universidad?',
  answer: 'Sí. El contenido está armado sobre el núcleo común de la carrera de Medicina en Argentina y es compatible con UBA, UNC, UNLP, USAL y la mayoría de las universidades del país. Las materias pueden tener nombres distintos según la cátedra, pero el contenido clínico y teórico es el mismo.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 relative" style={{
    background: 'linear-gradient(180deg, rgb(240,249,255) 0%, rgb(248,251,255) 15%, rgb(248,251,255) 85%, rgb(240,249,255) 100%)'
  }} data-id="element-180">
      <div className="mx-auto max-w-4xl" data-id="element-181">

        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-182">
          Preguntas{' '}
          <span style={{
          color: '#0284c7'
        }} data-id="element-183">frecuentes</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-184">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-185">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm transition-all" style={{
            border: isOpen ? '1px solid rgba(2,132,199,0.5)' : '1px solid rgba(14,165,233,0.15)'
          }} data-id="element-186">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-187">
                  <span className="text-sm font-bold" style={{
                color: isOpen ? '#0284c7' : '#111827'
              }} data-id="element-188">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black transition-transform duration-300" style={{
                backgroundColor: '#0284c7',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)'
              }} data-id="element-189">
                    +
                  </span>
                </button>

                {/* Answer */}
                {isOpen && <div className="px-5 pb-4" style={{
              borderTop: '1px solid rgba(14,165,233,0.1)'
            }} data-id="element-190">
                    <p className="text-sm text-gray-600 leading-relaxed m-0 pt-3" data-id="element-191">
                      {faq.answer}
                    </p>
                  </div>}
              </div>;
        })}
        </div>
      </div>

      {/* Degradé de integración con DarkCTA */}
      <div className="absolute bottom-0 left-0 right-0 h-16 pointer-events-none" style={{
      background: 'linear-gradient(to bottom, transparent 0%, rgb(240,249,255) 100%)'
    }} data-id="element-192" />
    </section>;
}